import React from "react";
import image from '../../../images/situation/nluiken/aantalLuiken.jpg'
import PropTypes from "prop-types";

Luiken.propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
    onEnter: PropTypes.func.isRequired
}
export default function Luiken(props) {
    return <div className="phone-page-middle">
        <div className="phone-situation-title">
            Hier kunt u invullen hoeveel luiken deze specifieke situatie bevat.<br/>
        </div>
        <div className="phone-situation-description">
            Voorbeeld:<br/>
            Als u twee kozijnen heeft binnen deze situatie en één kozijn bevat twee luiken dan voert u hier 4 in.<br/>
        </div>
        <input
            className="phoneInput"
            onChange={props.onChange}
            value={props.value}
            type="number"
            inputMode="numeric"
            onKeyDown={event => event.key === 'Enter' ? props.onEnter() : null}
            placeholder="Vul hier uw aantal luiken in..."
        />
        <img className="explainImagePhone" src={image} alt=""/>
    </div>;
}
